<template>
  <v-dialog
    v-model="dialog"
    width="1250px">
    <div class="dialog-container">
      <div class="dialog-header">
        <div class="flex">
          <span
            class="table-icon__img mg-r-10">
            <img :src="getOptionName('serverTypeIcon',customerType)" >
          </span>
          <span class="header-title">Attach {{customerType==2?'Referrer':'Policyholder'}}</span>
        </div>
        <i
          class="el-icon-close pointer"
          @click="dialog = false"></i>
      </div>
      <div class="dialog-body">
        <div class="filter-top">
          <!--      <span>Search</span>-->
          <v-input
            v-model="search"
            :prefixIcon="'el-icon-search'"
            placeholder="ID, Name, Registered Login, Contact, Phone or Email"
            @keyEnter="filterData"
          />
        </div>
        <div class="filter-container">
          <!--      <div>-->
          <div class="filter-left-container">
            <div class="flex">
              <div class="type-button">
                <div class="filter-box-text">
                  <span>Type</span>
                  <span class="flex ">
                    <span @click="handlerFilter('type','list')">All</span>
                    <span @click="handlerClearFilter('type')">None</span>
                  </span>
                </div>
                <v-checkbox-group
                  v-model="type"
                  :list="list"
                  @change="filterData"
                />
              </div>
              <div class="status-button">
                <div class="filter-box-text">
                  <span>Status</span>
                  <span class="flex ">
                    <span @click="handlerFilter('status','statusOption')">All</span>
                    <span @click="handlerClearFilter('status')">None</span>
                  </span>
                </div>
                <v-checkbox-group
                  v-model="status"
                  :list="statusOption"
                  @change="filterData"
                />
              </div>
              <div class="status-verify">
                <div class="filter-box-text">
                  <span>Verified</span>
                  <span class="flex ">
                    <span @click="handlerFilter('verify_type','verifyOptions')">All</span>
                    <span @click="handlerClearFilter('verify_type')">None</span>
                  </span>
                </div>
                <v-checkbox-group
                  v-model="verify_type"
                  :list="verifyOptions"
                  @change="filterData"
                />
              </div>
              <div class="filter-box">
                <div class="filter-box-text">
                  <span>Tags</span>
                  <span class="flex ">
                    <span @click="handlerFilter('tags')">All</span>
                    <span @click="handlerClearFilter('tags')">None</span>
                  </span>
                </div>
                <div class="flex-column">
                  <!-- <v-checkbox
              v-model="referralRequestStts"
              :isBoolean="false"
              class="span-status"
              @change="filterData"
            >Need Approval</v-checkbox
            > -->
                  <v-checkbox
                    v-model="uploadRequestStts"
                    :isBoolean="false"
                    class="upload-status mg-b-5"
                    @change="filterData"
                  >Unread Upload</v-checkbox>
                  <v-checkbox
                    v-model="tier_base"
                    :isBoolean="false"
                    class="diamond-status  mg-b-5"
                    @change="filterData"
                  >Professional</v-checkbox>
                  <v-checkbox
                    v-model="is_flagged"
                    :isBoolean="false"
                    class="upload-status  mg-b-5"
                    @change="filterData"
                  >Flagged</v-checkbox>
                  <v-checkbox
                    v-model="is_blocked"
                    :isBoolean="false"
                    class="blocked-status"
                    @change="filterData"
                  >Blocked</v-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="transparent">
          <el-table
            :data="tableData"
            :header-row-class-name="'tableHeader'"
            style="width: 100%"
            @row-click="rowClick"
          >
            <el-table-column
              width="55">
              <template slot-scope="scope">
                <span :class="[scope.row.checked? 'radio-circle-checked': 'radio-circle' ]"></span>
                <!-- <span>{{ scope.row.checked }}</span> -->
                <!-- <el-radio v-model="tableRadio[scope.$index].checked"/> -->
              </template>
            </el-table-column>
            <el-table-column
              prop="id"
              width="45"
            >
              <template #default="{row}">
                <font-awesome-icon
                  :class="{'orange': row.is_flagged}"
                  :icon="row.is_flagged? 'person-circle-exclamation' : 'user'" />
              </template>
            </el-table-column>
            <el-table-column
              width="100">
              <template slot-scope="scope">
                <span  class="span-status type-status">{{ scope.row.identity_language }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="isrd_nm"
              width="220"
              :show-overflow-tooltip="true"
              label="Name">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.is_green_tip"
                  class="green_tip">{{scope.row.green_tip}}</span>
                <span
                  class="showLick"
                  :class="{'unname' : scope.row.isrd_nm == ' '}">
                  {{ scope.row.isrd_nm != ' '? scope.row.isrd_nm : 'Unnamed Account'}}
                </span>
                <p class="liter-text">#{{ scope.row.id }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="registered_login"
              width="300"
              label="Registered Login & Contact"
            >
              <template slot-scope="scope">
                <span
                  class="login-text"
                  :class="{'color-purple':scope.row.attached_account}">{{ scope.row.registered_login }}</span>
                <p
                  v-if="scope.row.identity==2"
                  class="liter-text">{{ scope.row.contact_nm }} {{ scope.row.contact_phone}} {{scope.row.contact_email}}</p>
              </template>
            </el-table-column>
            <!--        <el-table-column-->
            <!--          prop="contact_nm"-->
            <!--          label="Contact (Company)"-->
            <!--        ></el-table-column>-->
            <!--        <el-table-column-->
            <!--          prop="contact_phone"-->
            <!--          label="Phone (Company)"-->
            <!--        ></el-table-column>-->
            <el-table-column
              prop="policy_num"
              label="Policy"
            ></el-table-column>
            <el-table-column
              label="Status & Tags"
              width="140"
            >
              <template #default="{ row }">
                <div class="flex">
                  <span
                    class="span-status"
                    :class="{
                      'success': row.status == 1,
                      'warning': row.status == 2,
                      'error': row.status == 0
                    }">{{ row.status_language }}</span>
                </div>

                <div class="flex tags">
                  <!-- <span
                v-if="row.verified != 20"
                class="span-status warning-plain">Need Approval</span> -->
                  <span
                    v-if="row.upload_request_stts == 1"
                    class="span-status unread-uplod">Unread Upload</span>
                </div>
                <div
                  v-if="row.is_tier_base"

                  class="flex tags">
                  <span
                    class="span-status diamond-status">Professional</span>
                </div>
                <div
                  v-if="row.is_flagged"
                  class="flex tags">
                  <span class="span-status unread-uplod">Flagged</span>
                </div>
                <div
                  v-if="row.is_blocked"
                  class="flex tags">
                  <span
                    class="span-status blocked-status">Blocked</span>
                </div>
              </template>

            </el-table-column>
            <el-table-column
              label="Verified"
              width="140">
              <template #default="{row}">
                <div class="flex">
                  <span
                    v-if="row.verify_language"
                    class="span-status"
                    :class="{
                      'verified': row.verified == 20,
                      'pending_verify ': row.verified == -1,
                      'not_verify': row.verified == -2
                    }">{{ row.verify_language }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <v-button
                  type="text"
                  :stop="true"
                  @click="handlerView(scope.row)">View</v-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="flex-sb-center flex-end">
          <span><v-button
            gray
            @click="dialog = false">Cancel</v-button></span>
          <v-pagination
            :total="pageConfig.total"
            :current="pageConfig.currentPage"
            @currentChange="currentChange" />
          <span><v-button
            green
            @click="handlerAttach">Confirm</v-button></span>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
// import AccountForm from '../../accounts/components/form/account-form'
// import AddressForm from '@/views/components/address-form'
import {getCustomerList} from '@/api/account'
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'

export default {
  name: 'Accounts',
  mixins: [MixinOptions],
  props:{
    isShare:{
      type: Boolean,
      default: false
    },
    customerType :{
      type: Number,
      default: 1
    },
    isAllType:{
      type: Boolean,
      default: false
    },
    isNewSME: {
      type: Boolean,
      default: false
    },
    canSelectAll: {
      type: Boolean,
      default: false
    },
    commercialCustomerType: {
      type: Number,
      default: 0
    },
    isMotorTrade:{
      type:Boolean,
      default:false
    },
    motorCustType:{
      type:Number,
      default:0
    },
    isTierBase:{
      type:Boolean,
      default:false
    },
    isPersonal:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dialog:false,
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      selectRow: '',
      type: [],
      search: '',
      tableData: [],
      status: [],
      referralRequestStts: 0,
      uploadRequestStts: 0,
      subForm: {
        'base-info': false,
        'address-info': false
      },
      customerFormData: {},
      filterList: [
        {
          name: 'Personal',
          id: 1
        },
        {
          name: 'Company',
          id: 2
        }
      ],
      verify_type:[],
      tier_base:0,
      is_flagged: 0,
      is_blocked: 0,
    }
  },
  computed: {
    ...mapState('common', ['productId', 'carClassId']),
    list() {
      let arr = this.filterList
      if (this.isAllType || this.customerType == 2) {
        return arr
      }
      if([13,14,16,18,21,22].includes(Number(this.productId))||this.isMotorTrade&&this.motorCustType==1|| this.isCommercialPersonal||this.isPersonal){
        arr = [ {
          name: 'Personal',
          id: 1
        },]
      }
      if([15].includes(Number(this.productId))||this.isNewSME||this.isMotorTrade&&this.motorCustType==2 || this.isCommercialCompany){
        arr = [ {
          name: 'Company',
          id: 2
        }]
      }
      return arr
    },
    isCommercial() {
      return this.productId == 11 && this.carClassId == 12
    },
    isNotCommercial() {
      return this.productId == 11 && this.carClassId != 12
    },
    isCommercialPersonal() {
      return this.isCommercial && this.commercialCustomerType == 1
    },
    isCommercialCompany() {
      return this.isCommercial && this.commercialCustomerType == 2
    },
    verifyOptions() {
      return this.specialOptions.verify_type
    }
  },
  watch:{
    dialog:{
      immediate:true,
      handler(val){
        if (val) {
          if ([17, 20].includes(Number(this.productId)) || this.isNotCommercial) {
            this.type = [1, 2]
          } else if ([12, 13, 14, 16, 18, 19,21, 22].includes(Number(this.productId)) || this.isCommercialPersonal) {
            this.type = [1]
          }else {
            this.type = [2]
          }
          if(this.isPersonal)
            this.type = [1]
          if(this.isMotorTrade){
            this.type = [this.motorCustType]
          }
          let {product_id, sme_versions} = this.$route.query
          if (sme_versions == 3 || this.isNewSME || this.isCommercialCompany) {
            this.type = [2]
          }
          if (this.customerType == 2) {
            this.type = [1, 2]
          }
          if (this.canSelectAll) {
            this.type = [1, 2]
          }
          if(this.isTierBase){
            this.tier_base = 1
          }
          this.network().getCustomerList()
        }
      }
    },
    customerType:{
      immediate:true,
      handler(val){
        if(val==2){
          this.type = [1,2]
        }
      }
    }
  },
  created() {
    // // 根據 product id 來默認篩選 公司 or 個人
    // if([11, 17,20].includes(Number(this.productId))) {
    //   this.type = [1, 2]
    // }
    // else if([12, 13, 14, 16, 18, 19,22].includes(Number(this.productId))) {
    //   this.type = [1]
    // }
    // else {
    //   this.type = [2]
    // }
    // let {product_id,sme_versions} = this.$route.query
    // if(sme_versions==3||this.isNewSME){
    //   this.type = [2]
    // }
    // if(this.customerType==2){
    //   this.type = [1, 2]
    // }
    // if(this.canSelectAll){
    //   this.type = [1,2]
    // }
    // this.network().getCustomerList()
  },
  methods: {
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    ...mapActions('quote', ['setQuoteForm']),
    showAttachCustomer(){
      this.dialog = !this.dialog
    },
    handlerFilter(name,option){
      if(name=='tags')
      {
        this.referralRequestStts=1
        this.uploadRequestStts=1
        this.tier_base = 1
        this.is_flagged = 1
        this.is_blocked = 1
      }
      else
      {
        const data = this[option].reduce((result, item) => {
          result.push(item.id)
          return result
        }, [])
        this[name] = data
      }
      this.filterData()
    },
    handlerClearFilter(name){
      this[name] = []
      if(name=='tags')
      {
        this.referralRequestStts=0
        this.uploadRequestStts=0
        this.tier_base = 0
        this.is_flagged = 0
        this.is_blocked = 0
      }
      this.filterData()
    },
    //查看用户详情
    handlerView({ id }) {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: id
        }
      })
    },
    //选择用户
    rowClick(row) {
      const { index } = row
      this.tableData.map(item => {
        item.checked = false
      })
      this.tableData[index].checked = true
      this.selectRow = index
      //   this.$router.push('/accounts/detail')
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getCustomerList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCustomerList()
    },
    handlerAttach() {
      if(this.selectRow === '') {
        this.$message({
          type: 'warning',
          message: '請先選擇用戶'
        })
        return
      }
      if(this.isShare){
        this.$emit('shareUser',this.tableData[this.selectRow].id,this.tableData[this.selectRow])
        this.dialog = false
        return
      }
      if(this.customerType==2){
        this.setSelectReferCustomerData(this.tableData[this.selectRow])
        this.setReferCustomerId(this.tableData[this.selectRow].agent_id)
      }else
      {
        this.setSelectCustomerData(this.tableData[this.selectRow])
        this.setCustomerId(this.tableData[this.selectRow].id)
      }
      let customerId = this.tableData[this.selectRow].id
      this.dialog = false
      this.$emit('handlerSelectCustomer',customerId)
      // this.setQuoteForm(null)
      // this.$router.push('/quoting/underwriting')
    },
    network() {
      return {
        getCustomerList: async () => {
          let { data } = await getCustomerList({
            type: this.type,
            search: this.search,
            page: this.pageConfig.currentPage,
            status: this.status,
            referral_request_stts: this.referralRequestStts,
            upload_request_stts:this.uploadRequestStts,
            tier_base: this.tier_base,
            verify_type: this.verify_type,
            is_flagged : this.is_flagged,
            is_blocked: this.is_blocked,
            customer_type :this.customerType
          })
          data.data.map((item, index) => {
            item.checked = false
            item.index = index
            return item
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
          // this.pageConfig.pageSize = data.per_page
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
  padding-top: 0;
  color: #616266;
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: #F6F8FA;
    .header-title{
      color: #1B1F23;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px;
    }
  }
  .dialog-body {
    padding: 30px;
    border-top: 1px solid var(--border-primary, #E1E4E8);
    .el-checkbox-group{
      display: block;
    }
    .filter-flex {
      margin-top: 10px;
      .form-item:first-child {
        margin-right: 15px;
        width: 400px;
      }

      .form-item:last-child {
        width: 400px;
      }
    }

    .filter-container {
      display: flex;
      align-items: center;
      margin: 10px auto 20px 0;

      & > span:first-child {
        font-size: 12px;
        font-weight: bold;
      }

      .filter-checkbox {
        margin: 0 20px;
      }

      .input-container {
        width: 360px;
      }
    }
  }
  .span-status {
    display: block;
    margin-right: 5px;
    padding: 0 10px;
    height:  20px;
    line-height: 20px;
    border-radius: 25px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    &.success {
      color:  rgb(67, 181, 92);
      background: rgb(220, 255, 228);
    }
    &.warning {
      background: rgb(255, 245, 177);
      color: rgb(218, 193, 93);
    }
    &.error {
      background: rgb(215, 58, 73);
      color: white;
    }
    &.warning-plain {
      border: 1px solid #B08800;
      color: #B08800;
    }
    &.unread-uplod {
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border: 1px solid #F66A0A;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      color: #C24E00;
    }
    &.diamond-status{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #0366D6;
      color: #0366D6;
    }
    &.verified{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #22863a;
      color: #22863a;
    }
    &.pending_verify{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #dbab09;
      color: #dbab09;
    }
    &.not_verify{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #d73a49;
      color: #d73a49;
    }
    &.blocked-status{
      padding: 0 8px;
      font-size: 12px;
      background: #FFFFFF;
      border-radius: 100px;
      line-height: 20px;
      white-space: nowrap;
      border: 1px solid #CB2431;
      color: #D73A49;
    }
    &.type-status{
      border: 1px solid #E1E4E8;
      color: #24292E;
    }
  }
  .filter-top{
    margin-bottom: 30px;
  }
  .filter-container {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    padding: 16px;
    //justify-content: space-between;
    .filter-box-text{
      display: flex;
      margin-bottom: 12px;
      /*justify-content: space-between;*/
      margin-right: 20px;
      span{
        margin-right: 10px;
        font-family: Inter;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 17px;
      }
      span:first-child{
        color: #24292E;
        font-weight: 600;

      }
      .flex{
        span{
          color: #0366D6;
          cursor: pointer;
        }
      }
    }
    .filter-left-container {
      display: flex;
      flex-direction: column;
    }
    & > span:first-child {
      font-size: 12px;
      font-weight: bold;
    }

    .filter-checkbox {
      margin: 0 20px;
    }

    .input-container {
      max-width: 360px;
    }
    .button-right {
      // position: absolute;
      // right: 0;
      margin-left: 20px;
    }

    .filter-box {
      margin-right: 20px;
      .span-status {
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          border: 1px solid #b08800;
          color: #b08800;
          background: white;
          border-radius: 50px;
          line-height: 20px;
          white-space: nowrap;
        }
      }
      .upload-status {
        display: flex;
        align-items: center;
        margin-right: 15px;
        // padding: 0 10px;
       /deep/ .el-checkbox__label {
            margin-left: 10px;
            padding: 0 10px;
            font-size: 12px;
            background: #FFFFFF;
            border: 1px solid #F66A0A;
            border-radius: 100px;
            line-height: 20px;
            white-space: nowrap;
            color: #C24E00;
          }
      }

      .diamond-status{
        display: flex;
        align-items: center;
       /deep/ .el-checkbox__label {
            margin-left: 10px;
            padding: 0 10px;
            font-size: 12px;
            background: #FFFFFF;
            border-radius: 100px;
            line-height: 20px;
            white-space: nowrap;
            border: 1px solid #0366D6;
            color: #0366D6;
          }
      }
      .blocked-status{
        display: flex;
        align-items: center;
        /deep/ .el-checkbox__label {
          margin-left: 10px;
          padding: 0 10px;
          font-size: 12px;
          background: #FFFFFF;
          border-radius: 100px;
          line-height: 20px;
          white-space: nowrap;
          border: 1px solid #CB2431;
          color: #D73A49;
        }
      }
    }
    .status-button {
      // margin-right: 20px;
      margin:0 30px;
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          .el-checkbox__label {
            span {
              display: inline-block;
              padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 12px;
              border: 0;
              border-radius: 50px;
            }
          }
          &:nth-child(3) {
            .el-checkbox__label {
              span {
                background: rgb(215, 58, 73);
                color: white;
              }
            }
          }
          // &:last-child {
          //    .el-checkbox__label{
          //     span{
          //       border:1px solid #B08800;
          //       color: #B08800;
          //       background: white;
          //     }
          //   }
          // }
          &:first-child {
            .el-checkbox__label {
              span {
                background: rgb(220, 255, 228);
                color: rgb(67, 181, 92);
              }
            }
          }
          &:nth-child(2) {
            .el-checkbox__label {
              span {
                background: rgb(255, 245, 177);
                color: rgb(218, 193, 93);
              }
            }
          }
        }
      }
    }
    .status-verify{
      margin: 0 30px;
      /deep/.el-checkbox-group {
        .el-checkbox {
          //display: flex;
          //align-items: center;
          &:first-child {
            .el-checkbox__label {
              padding: 0 10px;
              margin-left: 10px;
              font-size: 12px;
              background: #FFFFFF;
              border-radius: 100px;
              line-height: 20px;
              white-space: nowrap;
              border: 1px solid #d73a49;
              color: #d73a49;
            }
          }
          &:nth-child(2) {
            .el-checkbox__label {
              padding: 0 10px;
              margin-left: 10px;
              font-size: 12px;
              background: #FFFFFF;
              border-radius: 100px;
              line-height: 20px;
              white-space: nowrap;
              border: 1px solid #dbab09;
              color: #dbab09;
            }
          }
          &:nth-child(3) {
            .el-checkbox__label {
              padding: 0 10px;
              margin-left: 10px;
              font-size: 12px;
              background: #FFFFFF;
              border-radius: 100px;
              line-height: 20px;
              white-space: nowrap;
              border: 1px solid #22863a;
              color: #22863a;
            }
          }
        }
      }
    }
    .type-button {
      // margin-right: 20px;
      ::v-deep .el-checkbox-group {
        .el-checkbox {
          .el-checkbox__label {
            span {
              display: inline-block;
              padding: 0px 10px;
              height: auto;
              //line-height: 30px;
              font-size: 12px;
              border-radius: 50px;
              border: 1px solid #E1E4E8;
              color: #24292E;
              background: white;
              font-weight: 500;
              letter-spacing: 0;
              line-height: 18px;
            }
          }
        }
      }
    }

    .el-checkbox-group {
      //display: flex;
      //flex-wrap: nowrap;
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }
  }
  .flex-aglin{
    align-items: center;
  }
  .el-table{
    p:first-child{
      color: #24292E;
      font-size: 14px;
      font-weight: 500;
    }
    .login-text{
      color: #24292E;
      font-family: Inter;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 17px;
    }
    .liter-text{
      color: #6A737D;
      font-family: Inter;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 15px;
    }
    .tags{
      margin-top: 2px;
    }
  }
  ::v-deep .el-checkbox-group{
    .el-checkbox__label span{
      line-height: 20px;
    }
  }
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #D5D8DE;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: '';
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .showLick{
    color:  #000;
    text-decoration: none;
    &:hover{
      color:  #0366D6;
    }
  }
  .unname{
    font-style: italic;
    color: #6A737D;
  }
  .green_tip{
    color: rgb(67, 181, 92);
  }
  .orange{
    color: #E36209;
  }
}
.flex-end{
  align-items: end;
}
</style>
